import React, { useState, useEffect } from "react";
import { Stage, Layer, Rect, Image } from "react-konva";
import ContextMenu from "../ContextMenu";
import Konva from "konva";
import Rectangle from "./Rectangle";
import Icon from "../Icon";

//icons for context menu
import { FiCopy } from "react-icons/fi";
import { MdDelete } from "react-icons/md";
import { CgAlignLeft, CgAlignRight, CgAlignTop, CgAlignBottom, CgAlignCenter, CgAlignMiddle } from "react-icons/cg";

// TODO: attach mouse events to rect,
// instead of having everything handled by the Stage
// -- also, do the same for the other canvases

// This is used for the duplication function.
// It is placed here for scope reasons.
let temp = null;

const SelectCanvas = (props) => {
  const {
    background,
    canvasWidth,
    canvasHeight,
    scale,
    stageRef,
    bgRef,
    rects,
    setRects,
    triggers,
    points,
    deselectAll,
    minScale,
    colorPickerVisible,
    readFill,
    readOpacity,
    updatePointCoords,
    setListening,
  } = props;

  const [selectionRect, setSelectionRect] = useState({
    visible: false,
    x1: null,
    y1: null,
    x2: null,
    y2: null,
  });
  const [contextMenu, setContextMenu] = useState({
    visible: false,
    x: null,
    y: null,
  });

  const [forceUpdate, setForceUpdate] = useState(0);
  const [forceUpdateIDs, setForceUpdateIDs] = useState(0);

  // useEffect(() => {
  //   console.log('rects:', rects);
  //   // console.log('selection:', selection);
  // }, [rects]);

  useEffect(() => {
    setForceUpdate(0);
    setForceUpdateIDs(0);
    // document.addEventListener("keydown", handleKeyDown);
    // document.addEventListener('keyup', handleKeyUp);
    // return () => {
    //   document.removeEventListener("keydown", handleKeyDown);
    //   document.addEventListener('keyup', handleKeyUp);
    // };
  }, []);

  // I probably shouldn't have to do this
  // This is for updating the selection after duplicating
  useEffect(() => {
    if (forceUpdate > 0) {
      if (temp) {
        setRects([...rects, ...temp]);
        temp = null;
      }
    }
  }, [forceUpdate]);

  useEffect(() => {
    hideContextMenu();

    if (rects) {
      setRects(
        rects.map((rect, i) => {
          return { ...rect, id: i };
        })
      );
    }
  }, [forceUpdateIDs]);

  const selectObject = (obj) => {
    setRects(
      rects.map((rect) => {
        if (rect.id === parseInt(obj.attrs.id)) {
          return {
            ...rect,
            selected: true,
          };
        } else {
          return {
            ...rect,
            selected: false,
          };
        }
      })
    );
    setForceUpdate(forceUpdate + 1);
  };

  //on mouse down
  const handleMouseDown = (e) => {
    if (e.target.id !== "contextMenu") {
      hideContextMenu();
    }

    // if the user clicks the image (or the blank canvas), start drawing selection box
    if (e.target === stageRef.current || e.target === bgRef.current) {
      const x = stageRef.current.getPointerPosition().x / scale.x; // need to compensate here for the canvas scale
      const y = stageRef.current.getPointerPosition().y / scale.x;
      setSelectionRect({
        visible: true,
        x1: x,
        y1: y,
        x2: x,
        y2: y,
      });
    }

    //if we touch a rect, select it
    if (e.target.name() === "rect" && !e.target.attrs.selected) {
      selectObject(e.target);
    }

    //if multiple are selected and we want to move
  };

  const handleDragStart = (rect) => {
    if (!rect.selected) {
      selectObject(rect);
    }
  };

  const handleDragMove = (e) => {
    const { target } = e;
    const obj = getObjectById(target.attrs.id);
    const movement = {
      x: target.x() - obj.x,
      y: target.y() - obj.y,
    };
    setRects(
      rects.map((rect) => {
        if (rect.selected) {
          return {
            ...rect,
            x: rect.x + movement.x,
            y: rect.y + movement.y,
          };
        } else return rect;
      })
    );
  };

  //on mouse up
  const handleMouseUp = (e) => {
    //if we have been moving selection rect, select the objects
    if (selectionRect.visible) {
      setSelectionRect({ ...selectionRect, visible: false });
      const selectionBounds = {
        x: Math.min(selectionRect.x1, selectionRect.x2),
        y: Math.min(selectionRect.y1, selectionRect.y2),
        width: Math.abs(selectionRect.x2 - selectionRect.x1),
        height: Math.abs(selectionRect.y2 - selectionRect.y1),
      };
      const selectedElements = rects.map((rect) => {
        return Konva.Util.haveIntersection(selectionBounds, rect);
      });
      setRects(
        rects.map((rect, i) => {
          return {
            ...rect,
            selected: selectedElements[i],
          };
        })
      );
    }
  };

  const handleMouseMove = (e) => {
    if (selectionRect.visible) {
      const x = stageRef.current.getPointerPosition().x / scale.x;
      const y = stageRef.current.getPointerPosition().y / scale.x;
      setSelectionRect({ ...selectionRect, x2: x, y2: y });
    }
  };

  const checkMultipleSelection = () => {
    let x = 0;
    rects.forEach((rect) => {
      if (rect.selected) {
        x++;
      }
    });
    return x > 1;
  };

  const deleteObject = () => {
    hideContextMenu();
    setRects(rects.filter((rect) => !rect.selected));
    setForceUpdateIDs(forceUpdateIDs + 1);
  };

  // object will only "look" like it has moved
  // — but will still have the old coordinates —
  // unless we call this function
  // const updateCoords = (i) => {
  //   setRects(
  //     rects.map((rect) => {
  //       if (rect.id === i) {
  //         return { ...rect, x: rects[i].x, y: rects[i].y };
  //       } else return rect;
  //     })
  //   );
  // };

  const updateSize = (i, obj) => {
    setRects(
      rects.map((rect) => {
        if (rect.id === i) {
          return {
            ...rect,
            x: obj.x,
            y: obj.y,
            width: obj.width,
            height: obj.height,
          };
        } else return rect;
      })
    );
  };

  const getObjectById = (id) => {
    return rects.find((item) => {
      return item.id === parseInt(id);
    });
  };

  // reassign ids to all the rects
  // const updateIds = () => {
  //   setForceUpdateIDs(forceUpdateIDs + 1);
  // };

  const generateContextOptions = (e) => {
    let multi = checkMultipleSelection();
    if (e.target.name() === "rect") {
      setContextMenuOptions([
        {
          name: "Duplicate",
          icon: <FiCopy size={20} />,
          func: duplicateSelection,
        },
        { name: "Delete", icon: <MdDelete size={20} />, func: deleteObject },
        {
          name: "Average width",
          func: averageWidth,
          disabled: !multi,
        },
        {
          name: "Average height",
          func: averageHeight,
          disabled: !multi,
        },
        {
          name: "Left",
          icon: <CgAlignLeft size={20} />,
          func: () => align("left"),
          disabled: !multi,
        },
        {
          name: "Right",
          icon: <CgAlignRight size={20} />,
          func: () => align("right"),
          disabled: !multi,
        },
        {
          name: "Top",
          icon: <CgAlignTop size={20} />,
          func: () => align("top"),
          disabled: !multi,
        },
        {
          name: "Bottom",
          icon: <CgAlignBottom size={20} />,
          func: () => align("bottom"),
          disabled: !multi,
        },
        {
          name: "Horizontal",
          icon: <CgAlignCenter size={20} />,
          func: () => align("h-center"),
          disabled: !multi,
        },
        {
          name: "Vertical",
          icon: <CgAlignMiddle size={20} />,
          func: () => align("v-center"),
          disabled: !multi,
        },
      ]);
    }
  };

  const duplicateSelection = () => {
    hideContextMenu();
    temp = JSON.parse(JSON.stringify(rects));
    deselectAll();
    let counter = -1;
    temp = temp.filter((rect) => rect.selected);
    temp.forEach((rect) => {
      counter += 1;
      rect.id = rects.length + counter;
    });
    temp.forEach((rect) => {
      // if moving the rect 10px to the right
      // would place part of it outside of the stage,
      // move it as much as we can
      if (rect.x + 10 + rect.width > canvasWidth) {
        rect.x = canvasWidth - rect.width;
      } else rect.x += 10;
      // same as before, but with the height of the stage
      if (rect.y + 10 + rect.height > canvasHeight) {
        rect.y = canvasHeight - rect.height;
      } else rect.y += 10;
    });
    setForceUpdate(forceUpdate + 1);
  };

  const align = (side) => {
    hideContextMenu();
    const temp = rects.filter((rect) => rect.selected);
    let totalLeft = 0,
      totalTop = 0,
      totalBottom = 0,
      totalRight = 0,
      totalHCenter = 0,
      totalVCenter = 0;
    temp.forEach((rect) => {
      totalTop += rect.y;
      totalLeft += rect.x;
      totalBottom += rect.y + rect.height;
      totalRight += rect.x + rect.width;
      totalHCenter += rect.x + rect.width / 2;
      totalVCenter += rect.y + rect.height / 2;
    });
    switch (side) {
      case "top":
        setRects(
          rects.map((rect) => {
            if (rect.selected) {
              return {
                ...rect,
                y: Math.floor(totalTop / temp.length),
              };
            } else return rect;
          })
        );
        break;
      case "bottom":
        temp.forEach((rect) => {
          totalTop += rect.y + rect.height;
        });
        setRects(
          rects.map((rect) => {
            if (rect.selected) {
              return {
                ...rect,
                y: Math.floor(totalBottom / temp.length - rect.height),
              };
            } else return rect;
          })
        );
        break;
      case "left":
        setRects(
          rects.map((rect) => {
            if (rect.selected) {
              return {
                ...rect,
                x: Math.floor(totalLeft / temp.length),
              };
            } else return rect;
          })
        );
        break;
      case "right":
        setRects(
          rects.map((rect) => {
            if (rect.selected) {
              return {
                ...rect,
                x: Math.floor(totalRight / temp.length - rect.width),
              };
            } else return rect;
          })
        );
        break;
      case "h-center":
        setRects(
          rects.map((rect) => {
            if (rect.selected) {
              return {
                ...rect,
                x: Math.floor(totalHCenter / temp.length - rect.width / 2),
              };
            } else return rect;
          })
        );
        break;
      case "v-center":
        setRects(
          rects.map((rect) => {
            if (rect.selected) {
              return {
                ...rect,
                y: Math.floor(totalVCenter / temp.length - rect.height / 2),
              };
            } else return rect;
          })
        );
        break;
      default:
        break;
    }
  };

  const averageWidth = () => {
    hideContextMenu();
    const temp = rects.filter((rect) => rect.selected);
    let tempWidth = 0;
    temp.forEach((rect) => {
      tempWidth += rect.width;
    });
    let newWidth = Math.floor(tempWidth / temp.length);
    setRects(
      rects.map((rect) => {
        if (rect.selected) {
          return {
            ...rect,
            width: newWidth >= minScale ? newWidth : minScale,
          };
        } else return rect;
      })
    );
  };

  const averageHeight = () => {
    hideContextMenu();
    const temp = rects.filter((rect) => rect.selected);
    let tempHeight = 0;
    temp.forEach((rect) => {
      tempHeight += rect.height;
    });
    let newHeight = Math.floor(tempHeight / temp.length);
    setRects(
      rects.map((rect) => {
        if (rect.selected) {
          return {
            ...rect,
            height: newHeight >= minScale ? newHeight : minScale,
          };
        } else return rect;
      })
    );
  };

  const handleContextMenu = (e) => {
    if (!(e.target === stageRef.current || e.target === bgRef.current)) {
      if (!e.target.attrs.selected) selectObject(e.target);
      generateContextOptions(e);
      showContextMenu(e);
      return;
    }
  };

  const showContextMenu = (e) => {
    setListening(false);
    setContextMenu({
      ...contextMenu,
      x: stageRef.current.getPointerPosition().x,
      y: stageRef.current.getPointerPosition().y,
      visible: true,
    });
  };

  const hideContextMenu = () => {
    setListening(true);
    setContextMenu({
      ...contextMenu,
      visible: false,
    });
  };

  const [contextMenuOptions, setContextMenuOptions] = useState([]);

  return (
    <div className="canvas">
      <Stage
        scale={scale}
        ref={stageRef}
        width={canvasWidth}
        height={canvasHeight}
        onContextMenu={handleContextMenu}
        onMouseDown={handleMouseDown}
        onMouseUp={handleMouseUp}
        onMouseMove={handleMouseMove}
      >
        <Layer>
          <Image image={background} ref={bgRef} />
        </Layer>
        <Layer>
          {triggers &&
            triggers.map((trigger, index) => {
              if (trigger.type === "rect") {
                return (
                  <Rect
                    key={index}
                    x={trigger.x}
                    y={trigger.y}
                    width={trigger.width}
                    height={trigger.height}
                    fill="#00000040"
                    stroke={"gray"}
                    opacity={0.4}
                    strokeWidth={1}
                    dash={[4, 3]}
                  />
                );
              } else {
                return (
                  <Icon
                    id={trigger.id}
                    key={trigger.id}
                    x={trigger.x}
                    y={trigger.y}
                    iconUrl={trigger.iconUrl}
                    color={trigger.color}
                    scale={trigger.scale}
                    canvasWidth={canvasWidth}
                    canvasHeight={canvasHeight}
                    canvasScale={scale}
                    opacity={0.25}
                  />
                );
              }
            })}
        </Layer>
        <Layer>
          {rects &&
            rects.map((rect, index) => {
              return (
                <Rectangle
                  key={index}
                  index={index}
                  // name={"rect"}
                  id={String(index)}
                  x={rect.x}
                  y={rect.y}
                  width={rect.width}
                  height={rect.height}
                  handleMouseDown={handleMouseDown}
                  fill={colorPickerVisible ? readFill : rect.selected ? "#03bafc" : "orange"}
                  opacity={colorPickerVisible ? readOpacity : rect.selected ? 0.3 : 0.3}
                  stroke="#000"
                  strokeWidth={1}
                  selected={rect.selected}
                  updateSize={updateSize}
                  rect={rect}
                  handleDragStart={handleDragStart}
                  handleDragMove={handleDragMove}
                  rects={rects}
                  setRects={setRects}
                  canvasWidth={canvasWidth}
                  canvasHeight={canvasHeight}
                  draggable
                  minScale={minScale}
                  colorPickerVisible={colorPickerVisible}
                />
              );
            })}
          {selectionRect.visible && (
            <Rect
              name="selection"
              x={Math.min(selectionRect.x1, selectionRect.x2)}
              y={Math.min(selectionRect.y1, selectionRect.y2)}
              width={Math.abs(selectionRect.x2 - selectionRect.x1)}
              height={Math.abs(selectionRect.y2 - selectionRect.y1)}
              fill="rgba(0,161,255,0.3)"
            />
          )}
          {points &&
            points.map((point) => {
              return (
                <Icon
                  id={point.id}
                  key={point.id}
                  x={point.x}
                  y={point.y}
                  iconUrl={point.iconUrl}
                  // customText={point.customText}
                  color={point.color}
                  draggable={true}
                  scale={point.scale}
                  canvasWidth={canvasWidth}
                  canvasHeight={canvasHeight}
                  canvasScale={scale}
                  updatePointCoords={updatePointCoords}
                />
              );
            })}
          {contextMenu.visible && (
            <ContextMenu id="contextMenu" x={contextMenu.x} y={contextMenu.y} options={contextMenuOptions} />
          )}
        </Layer>
      </Stage>
    </div>
  );
};

export default SelectCanvas;
